import React from 'react';
import styled from '@emotion/styled';

import NearestBlock from '../NearestBlock';
import MainBlock from '../MainBlock';
import PaymentBlock from '../PaymentBlock';
import WarehouseBlock from '../WarehouseBlock';
import PackingsBlock from '../PackingsBlock';
import ReturnsBlock from '../ReturnsBlock';
import DesktopHistoryBlock from '../HistoryBlock/DesktopHistoryBlock';
import ClientBlock from '../ClientBlock';
import DeliveryBlock from '../DeliveryBlock';
import CommentBlock from '../CommentBlock';
import MoreBlock from '../MoreBlock';
import WorksheetBlock from '../WorksheetBlock';
import DesktopHeader from '../Header/DesktopHeader';
import ShippingOptionsBlock from '../ShippingOptionsBlock';
import DocsBlock from '../DocsBlock';
import AdAttachmentsBlock from '../AdAttachmentsBlock';

const Wrapper = styled('div')`
  display: flex;
  .card-title {
    margin: 0;
  }
  .card-box {
    min-height: 200px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
    &.disabled,
    &.add-info {
      display: flex;
      flex-direction: column;
    }
  }
  .block-subtitle {
    color: #abb2c7;
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 700;
  }
  .change-link {
    color: #7e57c2;
    cursor: pointer;
    font-size: 14px;
  }
  .border-top {
    border-top: 1px solid #ccc;
    padding-top: 15px;
  }
  .blocked-block {
    border-top: 1px solid #ccc;
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #ccc;
  }
  .nearest-block-wrapper {
    width: 248px;
    margin-right: 24px;
    flex: none;
  }
  .main-block-wrapper {
    width: calc(100% + 24px);
    max-width: calc(100% - 248px);
  }

  @media (max-width: 1700px) {
    .nearest-block-wrapper {
      width: 220px;
    }
    .main-block-wrapper {
      max-width: calc(100% - 220px);
    }
  }

  @media (max-width: 1300px) {
    .nearest-block-wrapper {
      display: none;
    }
    .main-block-wrapper {
      max-width: calc(100% + 24px);
    }
  }
  .header-title {
    margin-bottom: 14px;
  }

  .status-badge,
  .payment-badge {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-left: 10px;
    font-size: 9px;
    text-transform: uppercase;
    border-radius: 10px;
    background: #ccc;
    border: 1px solid #fff;
    color: #296775;
    padding: 2px 8px 0;
    min-width: 80px;
    text-align: center;
    height: 19px;
    i {
      font-size: 12px;
      margin-top: -2px;
    }
    .payment-badge-main > div {
      text-align: left;
    }
  }
  .help-tooltip {
    left: auto;
    right: -20px;
  }

  .right-blocks {
    flex: 0 0 33.3333%;
    max-width: 33%;
  }

  .history-desktop,
  .history-mobile {
    padding: 0 12px;
  }
  .history-mobile {
    display: none;
  }

  @media (max-width: 992px) {
    .right-blocks {
      display: grid;
      grid-template-columns: 1fr 1fr;
      flex: 1;
      max-width: 100%;
      grid-column-gap: 24px;
    }
    .history-mobile {
      display: block;
      width: 100%;
    }

    .history-desktop {
      display: none;
    }
  }

  @media (max-width: 576px) {
    .right-blocks {
      display: grid;
      grid-template-columns: 1fr;
      flex: 1;
      max-width: 100%;
      grid-row-gap: 20px;
      padding: 0 12px;
    }
    .history-mobile {
      display: block;
      width: 100%;
    }

    .history-desktop {
      display: none;
    }
  }
`;

const DesktopLayout = (props) => {
  const {
    history,
    isNew,
    currentOrder,
    PaymentBadge,
    nearest,
    handleChangeOrder,
    haveProducts,
    loadingOrder,
    currentWarehouse,
    sum,
    isManualWarehouse,
    stickerUrl,
    loadingSticker,
    worksheetData,
    handleEditOrderItems,
    handleConfirmation,
    handleRefreshReserve,
    handleCancel,
    handleUpdateDeliveryResult,
    handlePacking,
    handleSendPackingControl,
    handleDownloadSticker,
    handleCopyOrder,
    actualizeOrder,
    loadingPayment,
    handleEditPayment,
    warehouses,
    handleEditOrder,
    orderHistory,
    loadingClient,
    handleEditClient,
    loadingComment,
    handleEditComment,
    handleEditDelivery,
    handleEditDiscounts,
    handlePhoneCallBack,
    isFbm,
    fbmType,
    showFbmDocsUnnecessary,
    actualizeOnlyOrderByIdRequest,
    isCopy,
    setIsCopy,
    unsavedMaterials,
    setUnsavedMaterials,
    updateBatch,
    switchBatchUpdate,
  } = props;

  return (
    <>
      <DesktopHeader
        history={history}
        isNew={isNew}
        currentOrder={currentOrder}
        PaymentBadge={PaymentBadge}
      />
      <Wrapper>
        <div className="nearest-block-wrapper">
          <NearestBlock
            isNew={isNew}
            data={nearest}
            currentOrder={currentOrder}
            handleChangeOrder={handleChangeOrder}
          />
        </div>
        <div className="row main-block-wrapper">
          <div className="col-12 col-lg-8">
            <MainBlock
              isNew={isNew}
              haveProducts={haveProducts}
              currentOrder={currentOrder}
              loadingOrder={loadingOrder}
              currentWarehouse={currentWarehouse}
              sum={sum}
              isManualWarehouse={isManualWarehouse}
              stickerUrl={stickerUrl}
              loadingSticker={loadingSticker}
              worksheetData={worksheetData}
              handleEditOrder={handleEditOrder}
              handleEditOrderItems={handleEditOrderItems}
              handleConfirmation={handleConfirmation}
              handleRefreshReserve={handleRefreshReserve}
              handleCancel={handleCancel}
              handleUpdateDeliveryResult={handleUpdateDeliveryResult}
              handlePacking={handlePacking}
              handleSendPackingControl={handleSendPackingControl}
              handleDownloadSticker={handleDownloadSticker}
              handleCopyOrder={handleCopyOrder}
              actualizeOrder={actualizeOrder}
              handleEditDiscounts={handleEditDiscounts}
              handlePhoneCallBack={handlePhoneCallBack}
              unsavedMaterials={unsavedMaterials}
              setUnsavedMaterials={setUnsavedMaterials}
              updateBatch={updateBatch}
              switchBatchUpdate={switchBatchUpdate}
            />
            <div className="row">
              <div className="col-12 col-sm-6 col-lg-12 col-xl-6">
                <PaymentBlock
                  haveProducts={haveProducts}
                  currentOrder={currentOrder}
                  sum={sum}
                  loadingPayment={loadingPayment}
                  PaymentBadge={PaymentBadge}
                  handleEditPayment={handleEditPayment}
                />
              </div>
              <div className="col-12 col-sm-6 col-lg-12 col-xl-6">
                <WarehouseBlock
                  warehouses={warehouses}
                  currentWarehouse={currentWarehouse}
                  currentOrder={currentOrder}
                  handleEditOrder={handleEditOrder}
                />
              </div>
            </div>

            {currentOrder.packings && currentOrder.packings.length ? (
              <div className="row">
                <div className="col-12">
                  <PackingsBlock
                    currentOrder={currentOrder}
                    requirements={worksheetData?.requirements}
                    actualizeOrder={actualizeOrder}
                  />
                </div>
              </div>
            ) : null}

            {currentOrder?.returns?.length ? (
              <div className="row">
                <div className="col-12">
                  <ReturnsBlock currentOrder={currentOrder} />
                </div>
              </div>
            ) : null}

            {orderHistory.length ? (
              <div className="history-desktop">
                <DesktopHistoryBlock orderHistory={orderHistory} currentOrderId={currentOrder.id} />
              </div>
            ) : null}
          </div>
          <div className="right-blocks">
            <ClientBlock
              isNew={isNew}
              currentOrder={currentOrder}
              loadingClient={loadingClient}
              handleEditClient={handleEditClient}
              handleEditOrder={handleEditOrder}
            />

            {worksheetData?.requirements?.form ? (
              <WorksheetBlock
                isNew={isNew}
                currentOrder={currentOrder}
                fields={worksheetData.form_content}
                actualizeOrder={actualizeOrder}
              />
            ) : null}

            {isFbm && !isNew && fbmType !== 'FBO_B2B' ? (
              <ShippingOptionsBlock currentOrder={currentOrder} handleEditOrder={handleEditOrder} />
            ) : null}

            <DeliveryBlock
              sum={sum}
              haveProducts={haveProducts}
              currentOrder={currentOrder}
              handleEditDelivery={handleEditDelivery}
              actualizeOrder={actualizeOrder}
            />

            <AdAttachmentsBlock
              currentOrder={currentOrder}
              haveProducts={haveProducts}
              handleEditOrder={handleEditOrder}
            />

            <CommentBlock
              currentOrder={currentOrder}
              haveProducts={haveProducts}
              loadingComment={loadingComment}
              handleEditComment={handleEditComment}
            />
            <DocsBlock
              currentOrder={currentOrder}
              actualizeOrder={actualizeOrder}
              handleEditOrder={handleEditOrder}
              isNew={isNew}
              showFbmDocsUnnecessary={showFbmDocsUnnecessary}
              actualizeOnlyOrderByIdRequest={actualizeOnlyOrderByIdRequest}
            />

            <MoreBlock
              currentOrder={currentOrder}
              handleEditOrder={handleEditOrder}
              fbmType={fbmType}
              actualizeOrder={actualizeOrder}
              setIsCopy={setIsCopy}
              isCopy={isCopy}
            />
          </div>

          {orderHistory.length ? (
            <div className="history-mobile">
              <DesktopHistoryBlock orderHistory={orderHistory} currentOrderId={currentOrder.id} />
            </div>
          ) : null}
        </div>
      </Wrapper>
    </>
  );
};

export default DesktopLayout;
